export const AENDERUNGEN_UEBERNOMMEN_30_SEK  = 'Ihre Änderungen wurden erfolgreich übernommen. Dies kann bis zu 30 Sekunden in Anspruch nehmen.';
